import React from "react";
import {ErrorMessage, useFormikContext} from "formik";
import RadioComponent from "../../../../../common/Radio";

export default function CyberAssuranceProtection1({translation}) {
    const formikProps = useFormikContext();

    return (
        <>
            <div className={'item'}>
                {formikProps.values['assistaFormChoice'] &&
                    <>
                        <label className={'form-label'}>
                            {translation('damageReasonLabel') + '*'}
                        </label>

                        <RadioComponent
                            data={{
                                id: 'assistaReasonDamage1',
                                value: translation('ASSISTA_Cap_Form_Step1_Label_Identity_Theft'),
                                name: 'assistaReasonDamage',
                                label: translation('ASSISTA_Cap_Form_Step1_Label_Identity_Theft') }}
                        />
                        <RadioComponent
                            data={{
                                id: 'assistaReasonDamage2',
                                value: translation('ASSISTA_Cap_Form_Step1_Label_Copyright'),
                                name: 'assistaReasonDamage',
                                label: translation('ASSISTA_Cap_Form_Step1_Label_Copyright') }}
                        />

                        {formikProps.values['assistaFormChoice'] &&
                            <ErrorMessage className={'text-danger'} name='assistaReasonDamage' component='div' />
                        }
                    </>
                }
            </div>

            <div className={'item'}>
                {formikProps.values['assistaFormChoice'] &&
                    <label className={'form-label'}>
                        {translation('documentsAndInfosLabel')}
                    </label>
                }

                <ul>
                    <li>{translation('contractLabel')}</li>
                    <li>{translation('correspondenceLabel')}</li>
                    <li>{translation('etCeteraLabel')}</li>
                </ul>
            </div>
        </>
    )
}